import React, { useRef } from "react";
import styled from "styled-components";
import LabelWithTooltip, {
  labelLayoutStyles, LABEL_CONTAINER_CLASS
} from "widgets/components/LabelWithTooltip";
import { LabelPosition } from "components/constants";
import _ from "lodash";
import { uuid2 } from "@byk/utils/Utils";
import EditableTable from "@byk/pages/components/EditableTableWidget";

interface ContainerProps {
  compactMode: boolean;
  labelPosition?: LabelPosition;
  textColorBody?: string,
  textSizeHead?: string,
  textColorHead?: string,
  backgroundHead?: string,
  backgroundBody1?: string,
  backgroundBody2?: string,
  backgroundMouseOver?: string,
  horizontalAlignmentHead?: string,
  verticalAlignmentHead?: string,
  horizontalAlignmentBody?: string,
  verticalAlignmentBody?: string,
  fontStyleHead?: string,
  fontStyleBody?: string,
  isZebraStripe?: boolean,
  boxShadow?: string,
  borderRadius?: string,
  variant?: string,
  borderColor?: string,
  borderWidth?: string,
  textSizeBody?: string,
  accentColor:string,
}

const DivContainer = styled.div<ContainerProps>`
  ${labelLayoutStyles}

  & .${LABEL_CONTAINER_CLASS} {
    align-self: center;
    ${({ labelPosition }) =>
    labelPosition === LabelPosition.Left && "min-height: 30px"};
  }
  .ant-table-body,
  .ant-table-body-inner {
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .ant-table-cell-scrollbar {
    display: none;
  }
  table{
    border: none!important;
  }
  table, th, td,.ant-table-container{
    border: none!important;
  }
  .ant-table-body{
    overflow: auto!important;
  }
  .ant-pagination a {color:${({ textColorBody }) => textColorBody }!important;}
  .ant-pagination .ant-pagination-item-active a {color:#40a9ff !important;}
  .ant-pagination .ant-pagination-item-link {color:${({ textColorBody }) => textColorBody }!important;}
  .ant-form-item-explain {
    position: absolute;
    //top: 6px !important;
    left: 0px !important;
    color: red;
    font-size: 14px;
    padding-left: 10px; /* 根据需要调整 */
  }
  thead {
    background: ${({backgroundHead}) => backgroundHead||"#fafafa"}!important;

    th:last-child {
      background: ${({backgroundHead}) => backgroundHead||"#fafafa"}!important;
    }
    th:first-child {
      background: ${({backgroundHead}) => backgroundHead||"#fafafa"}!important;
    }
  }
  .ant-table-thead  tr,.ant-table-thead th {
    background: transparent !important;
  }
  /*.ant-table-thead  tr,.ant-table-thead th {
    background: transparent !important;
  }*/
  /*.ant-table-cell-fix-left ,.ant-table-cell-fix-right{background:transparent !important;}*/
  th {
    font-size: ${({ textSizeHead }) => textSizeHead}!important;
    color:${({ textColorHead }) => textColorHead}!important;
    font-weight:${({ fontStyleHead }) => fontStyleHead && fontStyleHead.split(',')[0]}!important;
    font-style:${({ fontStyleHead }) => fontStyleHead && fontStyleHead.split(',')[1]}!important;
    text-align:${({ horizontalAlignmentHead }) => horizontalAlignmentHead}!important;
  }

  tbody td {
    font-size: ${({ textSizeBody }) => textSizeBody}!important;
    color:${({ textColorBody }) => textColorBody}!important;
    font-weight:${({ fontStyleBody }) => fontStyleBody && fontStyleBody.split(',')[0]}!important;
    font-style:${({ fontStyleBody }) => fontStyleBody && fontStyleBody.split(',')[1]}!important;
    text-align:${({ horizontalAlignmentBody }) => horizontalAlignmentBody}!important;
  }

  ${({ boxShadow }) => `
    .ant-table-container{
      box-shadow: ${boxShadow}
    }
  `}
  ${({ borderRadius }) => `
    .ant-table-container{
      border-radius: ${borderRadius}!important;
      overflow:hidden;
    }
    .ant-table{
      border-radius: ${borderRadius}!important;
    }
  `}

  .ant-table-placeholder .ant-table-cell {
     border: none!important;
     background: white !important;
  }
  ${({ variant, borderColor, borderWidth }) => `
    ${variant === "DEFAULT" || !variant ? `
      .ant-table-container {
        border: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }

      .ant-table-cell {
        border-left: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }

      .ant-table-cell:first-child{
        border-left: none!important;
      }

      .ant-table-row:last-child .ant-table-cell{
        border-bottom: none!important;
      }
    ` : ``}
  `}

  ${({ variant, borderColor, borderWidth }) => `
    ${variant === "VARIANT3" ? `
      .ant-table-thead .ant-table-cell,.ant-table-tbody .ant-table-row .ant-table-cell{
        border-bottom: ${borderWidth ?? 1}px solid ${borderColor || '#f0f0f0'}!important;
      }
    ` : ``}
  `}
  .ant-table-cell-row-hover{
    background:${({ backgroundMouseOver,backgroundBody1 }) => backgroundMouseOver=="transparent"?backgroundBody1:backgroundMouseOver}!important;
  }
  ${({ backgroundMouseOver }) =>
    backgroundMouseOver === "transparent"
      ? `
      .ant-table-tbody > tr.ant-table-row:hover > td,
      .ant-table-tbody > tr > td.ant-table-cell-row-hover {
        background-color: transparent !important;
      }
    `
      : ""}

  .ant-table-expanded-row-fixed{
    background: ${({ backgroundBody1 }) => backgroundBody1}!important;
  }

  ${({ isZebraStripe, backgroundBody1, backgroundBody2, backgroundMouseOver }) => `
    ${`

    tr:nth-child(odd){
      background: ${backgroundBody1};
      td.ant-table-cell-fix-left-last,td.ant-table-cell-fix-right-first
      {
        background: ${backgroundBody1};
      }
    }

    tr:nth-child(even){
      background: ${isZebraStripe ? backgroundBody2 : backgroundBody1};
      td.ant-table-cell-fix-left-last,td.ant-table-cell-fix-right-first
      {
        background: ${isZebraStripe ? backgroundBody2 : backgroundBody1};
      }
    }
    `}
  `}

  .tableDataCellCz {
    display: flex;
    padding: 0 8px 8px 8px !important;

    &>div {
      margin-top: 8px !important;
    }
  }

   .ant-pagination {
    padding-right: 8px;

    .ant-pagination-item-active a {
       color:${({accentColor}) => accentColor} !important;
    }

    .ant-pagination-item-link {
      color:${({accentColor}) => accentColor} !important;
    }
  }

  .ant-pagination-item-active {
    border-color:${({accentColor}) => accentColor} !important;
  }
`;

const CarouselComponent = (props: any) => {
  const { wrapperRef,
    compactMode,
    isDisabled,
    isLoading,
    isRequired,//
    labelAlignment,//11
    labelPosition,//11
    labelStyle,//11
    labelText,//11
    labelTextColor,//11
    labelTextSize,//11
    labelTooltip,//11
    labelWidth,//11
    onChange,
    label,
    defaultValue,
    vertical,
    onValueChange,
    value,
    jsValue,
    tableColumns,
    tableColumnsMap,
    readonly,
    selectId,
    onOptionChange,
    tableSize,
    textSizeHead,
    textColorHead,
    fontStyleHead,
    horizontalAlignmentHead,
    backgroundHead,
    textSizeBody,
    textColorBody,
    fontStyleBody,
    horizontalAlignmentBody,
    borderRadius,
    boxShadow,
    variant,
    borderColor,
    borderWidth,
    backgroundMouseOver,
    isZebraStripe,
    backgroundBody1,
    backgroundBody2,
    newBtnType,
    newBtnColor,
    newBtnFontStyle,
    newBtnTextSize,
    newBtnBgColor,
    newBtnBorderRadius,
    newBtnBoxShadow,
    opBtnType,
    opBtnColor,
    opBtnBgColor,
    opBtnFontStyle,
    opBtnTextSize,
    opBtnBorderRadius,
    opBtnBoxShadow,
    widgetName,
    accentColor,
    subCellEvents,
    upTableColumnsMap,
    onSaveCompleteChange,
    maxCount,
    isPropAdd,
    isPropOperation,
    isShowNo,
    onDeleteClick,
    onDelete,
    isPagination,
    pageSizeOptions,
    currPage,
    pageSize,
    total,
    paginationChange
    //LABEL END
  } = props;
  //列处理

  const onValChange = (value: any) => {
    onValueChange(value)
  };
  const onSaveCompleteChangeEvent = (value: any) => {
    onSaveCompleteChange(value)
  };

  const onSelectOptionChange = (event:any, record: any) => {
    onOptionChange(event, record)
  };

  const dataCache = useRef([]);
  const dataCacheUUID = useRef([]);

  const getCols = (cols: any) => {
    let _cols: any = [];
    const _tableColumns:any = _.sortBy(Object.values(cols), ['index']);
    if (_tableColumns) {
      let keys = Object.keys(_tableColumns);
      for (let i = 0; i < keys.length; i++) {
        let _val: any = { ..._tableColumns[keys[i]] };
        _val.title = _val.label;
        _val.dataIndex = _val.id;
        if (_val.columnType == "select") {
          _val.dataIndex = _val.id + ".value";
          _val.id = _val.id + ".value";
        }
        _val.required = _val.isCellRequired;
        _val.onOptionChange = _val.onOptionChange || undefined;
        _val.inputType = _val.columnType;
        if(_val.width){
          _val.width=parseInt(_val.width);
        }
        else{
          _val.flex=1;
          _val.width=150;
        }
        _val.editable = true;
        _val.dataIndex = `${widgetName}.${_val.dataIndex}`;
        _val.id = `${widgetName}.${_val.id}`;
        if(_val.isCellVisible!=false){
          _cols.push(_val);
        }
      }
    }
    return _cols;
  }

  const editRef = useRef<any>();

  const getDataSource = (data: any) => {
    if (_.isEqual(dataCache.current, data)) {
      return dataCacheUUID.current;
    }
    let _data = data || [];
    let _dataNew: any = [];
    _.each(_data, (i: any) => {
      let m: any = { ...i };
      if (!m.hasOwnProperty("key")) {
        if (m.hasOwnProperty("id")) {
          m["key"] = m.id;
          m["_hasId"] = true;
        }
        else {
          m["key"] = uuid2()
          m["_hasId"] = false;
        }
      }
      if (!m.hasOwnProperty("_subTable_action")) {
        m["_subTable_action"] = "update";
      }
      _dataNew.push(m);
    })
    dataCache.current = data;
    dataCacheUUID.current = _dataNew;
    return _dataNew;
  }


  return (
    <>
      <DivContainer compactMode={compactMode}
        data-testid="SubTableWidget-container"
        labelPosition={labelPosition}
        textSizeHead={textSizeHead}
        textColorHead={textColorHead}
        fontStyleHead={fontStyleHead}
        horizontalAlignmentHead={horizontalAlignmentHead}
        backgroundHead={backgroundHead}
        textSizeBody={textSizeBody}
        textColorBody={textColorBody}
        fontStyleBody={fontStyleBody}
        horizontalAlignmentBody={horizontalAlignmentBody}
        boxShadow={boxShadow}
        borderRadius={borderRadius}
        variant={variant}
        borderColor={borderColor}
        borderWidth={borderWidth}
        backgroundMouseOver={backgroundMouseOver}
        isZebraStripe={isZebraStripe}
        backgroundBody1={backgroundBody1}
        backgroundBody2={backgroundBody2}
        accentColor={accentColor}
        style={{height:"inherit",overflowY:"auto"}}
      >
        {label && (
          <LabelWithTooltip
            className={`datepicker-label`}
            text={label}
            cyHelpTextClassName="datepicker-tooltip"
            alignment={labelAlignment}
            color={labelTextColor}
            compact={compactMode}
            disabled={isDisabled}
            fontSize={labelTextSize}
            fontStyle={labelStyle}
            helpText={labelTooltip}
            //isDynamicHeightEnabled={this.props.isDynamicHeightEnabled}
            loading={isLoading}
            position={labelPosition}
            width={labelWidth}
            isRequired={isRequired}
          />
        )}
        <div style={{ width: labelPosition=="Left"?'80%':'100%',flex: 1 }}>
          <EditableTable
            ref={editRef} isDisabled={isDisabled} selectId={selectId}
            onOptionChange={onSelectOptionChange} size={tableSize}
            newBtnType={newBtnType}
            newBtnColor={newBtnColor}
            newBtnFontStyle={newBtnFontStyle}
            newBtnTextSize={newBtnTextSize}
            newBtnBgColor={newBtnBgColor}
            newBtnBorderRadius={newBtnBorderRadius}
            newBtnBoxShadow={newBtnBoxShadow}
            opBtnType={opBtnType}
            opBtnColor={opBtnColor}
            opBtnBgColor={opBtnBgColor}
            opBtnFontStyle={opBtnFontStyle}
            opBtnTextSize={opBtnTextSize}
            opBtnBorderRadius={opBtnBorderRadius}
            opBtnBoxShadow={opBtnBoxShadow}
            tableColumns={tableColumns}
            tableColumnsMap={tableColumnsMap}
            boxShadow={boxShadow}
            borderRadius={borderRadius}
            accentColor={accentColor}
            cols={getCols(tableColumns)}
            onValChange={onValChange}
            onSaveCompleteChange={onSaveCompleteChangeEvent}
            data={getDataSource(value)}
            jsValue={jsValue}
            upTableColumnsMap={upTableColumnsMap}
            maxCount={maxCount}
            subCellEvents={subCellEvents}
            isRequired={isRequired}
            isPropAdd={isPropAdd}
            isPropOperation={isPropOperation}
            isShowNo={isShowNo}
            onDeleteClick={onDeleteClick}
            onDelete={onDelete}
            isPagination={isPagination}
            pageSizeOptions={pageSizeOptions}
            currPage={currPage}
            pageSize={pageSize}
            total={total}
            paginationChange={paginationChange}
          />
        </div>
      </DivContainer>
    </>
  )
}

class ViewComponent extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return <CarouselComponent {...this.props} />;
  }
}
export default ViewComponent;
